// extracted by mini-css-extract-plugin
export var textInput = "_d3-0";